import * as svg from "./svg"
import * as theme from "layouts/theme"

export namespace nav {
	export const Icon = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
				<path
					d="M10.8 11.92L11.92 10.8C12 10.72 12.04 10.6267 12.04 10.52C12.04 10.4133 12 10.32 11.92 10.24L9.2 7.5C9.25333 7.35333 9.29333 7.20667 9.32 7.06C9.34667 6.91333 9.36 6.74667 9.36 6.56C9.36 5.8 9.09013 5.15013 8.5504 4.6104C8.01067 4.07067 7.36053 3.80053 6.6 3.8C6.37333 3.8 6.14667 3.83013 5.92 3.8904C5.69333 3.95067 5.47333 4.03387 5.26 4.14L7.14 6.02L6.02 7.14L4.14 5.26C4.03333 5.47333 3.95013 5.69333 3.8904 5.92C3.83067 6.14667 3.80053 6.37333 3.8 6.6C3.8 7.36 4.07013 8.01013 4.6104 8.5504C5.15067 9.09067 5.80053 9.36053 6.56 9.36C6.73333 9.36 6.8968 9.34667 7.0504 9.32C7.204 9.29333 7.35387 9.25333 7.5 9.2L10.24 11.92C10.32 12 10.4133 12.04 10.52 12.04C10.6267 12.04 10.72 12 10.8 11.92ZM8 16C6.89333 16 5.85333 15.7899 4.88 15.3696C3.90667 14.9493 3.06 14.3795 2.34 13.66C1.62 12.94 1.05013 12.0933 0.6304 11.12C0.210667 10.1467 0.000533333 9.10667 0 8C0 6.89333 0.210133 5.85333 0.6304 4.88C1.05067 3.90667 1.62053 3.06 2.34 2.34C3.06 1.62 3.90667 1.05013 4.88 0.6304C5.85333 0.210667 6.89333 0.000533333 8 0C9.10667 0 10.1467 0.210133 11.12 0.6304C12.0933 1.05067 12.94 1.62053 13.66 2.34C14.38 3.06 14.9501 3.90667 15.3704 4.88C15.7907 5.85333 16.0005 6.89333 16 8C16 9.10667 15.7899 10.1467 15.3696 11.12C14.9493 12.0933 14.3795 12.94 13.66 13.66C12.94 14.38 12.0933 14.9501 11.12 15.3704C10.1467 15.7907 9.10667 16.0005 8 16ZM8 14.4C9.78667 14.4 11.3 13.78 12.54 12.54C13.78 11.3 14.4 9.78667 14.4 8C14.4 6.21333 13.78 4.7 12.54 3.46C11.3 2.22 9.78667 1.6 8 1.6C6.21333 1.6 4.7 2.22 3.46 3.46C2.22 4.7 1.6 6.21333 1.6 8C1.6 9.78667 2.22 11.3 3.46 12.54C4.7 13.78 6.21333 14.4 8 14.4Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	Icon.defaultProps = {
		width: "16px",
		height: "16px",
		fill: theme.colors.grey.dark10,
	}

	export const Logos = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="36" height="42" viewBox="0 0 36 42" fill="none" {...rest}>
				<path
					d="M17.1418 1.31444C17.3014 1.2187 17.4824 1.16829 17.6667 1.16829C17.8509 1.16829 18.032 1.2187 18.1915 1.31444L33.8085 10.6854C33.9681 10.7812 34.1007 10.919 34.1929 11.085C34.285 11.2509 34.3335 11.4392 34.3333 11.6308V30.3708C34.3335 30.5624 34.285 30.7507 34.1929 30.9167C34.1007 31.0826 33.9681 31.2205 33.8085 31.3163L18.1915 40.6835C18.032 40.7793 17.8509 40.8297 17.6667 40.8297C17.4824 40.8297 17.3014 40.7793 17.1418 40.6835L1.52488 31.3126C1.3652 31.2168 1.23261 31.079 1.14047 30.913C1.04833 30.7471 0.999882 30.5588 1 30.3672V11.6308C0.999882 11.4392 1.04833 11.2509 1.14047 11.085C1.23261 10.919 1.3652 10.7812 1.52488 10.6854L17.1418 1.31444Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M26.4146 26.4546H8.91862L17.6666 11.9091L26.4146 26.4546Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M17.6667 11.9091L1.04557 11L8.91876 26.4545M17.6667 11.9091L34.2879 11L26.4147 26.4545M17.6667 11.9091V1M8.91876 26.4545L1.04557 31M8.91876 26.4545L17.6667 41L26.4147 26.4545M26.4147 26.4545L34.2879 31"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinejoin="round"
				/>
			</svg.SVG>
		)
	}

	Logos.defaultProps = {
		stroke: theme.colors.grey.dark50alpha60,
		strokeOpacity: "0.5",
	}

	export const Colors = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none" {...rest}>
				<path
					d="M11 46C8.34784 46 5.8043 44.9464 3.92893 43.0711C2.05357 41.1957 1 38.6522 1 36V6C1 4.67392 1.52678 3.40215 2.46447 2.46447C3.40215 1.52678 4.67392 1 6 1H16C17.3261 1 18.5979 1.52678 19.5355 2.46447C20.4732 3.40215 21 4.67392 21 6V36C21 38.6522 19.9464 41.1957 18.0711 43.0711M11 46C13.6522 46 16.1957 44.9464 18.0711 43.0711M11 46H41C42.3261 46 43.5979 45.4732 44.5355 44.5355C45.4732 43.5979 46 42.3261 46 41V31C46 29.6739 45.4732 28.4021 44.5355 27.4645C43.5979 26.5268 42.3261 26 41 26H35.1425M18.0711 43.0711L39.285 21.8575C40.2224 20.9199 40.7489 19.6483 40.7489 18.3225C40.7489 16.9967 40.2224 15.7251 39.285 14.7875L32.2125 7.715C31.2749 6.77764 30.0033 6.25107 28.6775 6.25107C27.3517 6.25107 26.0801 6.77764 25.1425 7.715L21 11.8575M11 36H11.025"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg.SVG>
		)
	}

	Colors.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Typography = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none" {...rest}>
				<path
					d="M1 14V8C1 4.13401 4.13401 1 8 1H14"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M31 0.999999L37 1C40.866 1 44 4.13401 44 8L44 14"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14 44L8 44C4.13401 44 1 40.866 1 37L1 31"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M44 31L44 37C44 40.866 40.866 44 37 44L31 44"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinejoin="round"
				/>
				<path d="M22 31L22 14" stroke={stroke} strokeOpacity={strokeOpacity} strokeWidth="2" strokeLinejoin="round" />
				<path
					d="M12.5 16.5V13.5C12.5 12.9477 12.9477 12.5 13.5 12.5H31C31.5523 12.5 32 12.9477 32 13.5V16.5"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.5 32.5H26"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg.SVG>
		)
	}

	Typography.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Imagery = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="48" height="40" viewBox="0 0 48 40" fill="none" {...rest}>
				<path
					d="M44.7619 0H10.4762C9.71843 0 8.9917 0.301019 8.45588 0.836837C7.92007 1.37266 7.61905 2.09938 7.61905 2.85714V7.61905H2.85714C2.09938 7.61905 1.37266 7.92007 0.836838 8.45588C0.30102 8.9917 0 9.71843 0 10.4762V37.1429C0 37.9006 0.30102 38.6273 0.836838 39.1632C1.37266 39.699 2.09938 40 2.85714 40H37.1429C37.9006 40 38.6273 39.699 39.1632 39.1632C39.699 38.6273 40 37.9006 40 37.1429V32.381H44.7619C45.5197 32.381 46.2464 32.0799 46.7822 31.5441C47.318 31.0083 47.619 30.2816 47.619 29.5238V2.85714C47.619 2.09938 47.318 1.37266 46.7822 0.836837C46.2464 0.301019 45.5197 0 44.7619 0ZM9.52381 2.85714C9.52381 2.60456 9.62415 2.36231 9.80275 2.18371C9.98136 2.0051 10.2236 1.90476 10.4762 1.90476H44.7619C45.0145 1.90476 45.2567 2.0051 45.4353 2.18371C45.6139 2.36231 45.7143 2.60456 45.7143 2.85714V20.0952L41.6929 16.0738C41.4274 15.8074 41.112 15.5961 40.7647 15.4519C40.4174 15.3077 40.0451 15.2335 39.669 15.2335C39.293 15.2335 38.9207 15.3077 38.5734 15.4519C38.2261 15.5961 37.9107 15.8074 37.6452 16.0738L32.2095 21.5095L21.069 10.3595C20.8036 10.0932 20.4882 9.88182 20.1409 9.73761C19.7936 9.59341 19.4213 9.51918 19.0452 9.51918C18.6692 9.51918 18.2969 9.59341 17.9496 9.73761C17.6023 9.88182 17.2869 10.0932 17.0214 10.3595L9.52381 17.8571V2.85714ZM38.0952 37.1429C38.0952 37.3954 37.9949 37.6377 37.8163 37.8163C37.6377 37.9949 37.3954 38.0952 37.1429 38.0952H2.85714C2.60456 38.0952 2.36231 37.9949 2.18371 37.8163C2.0051 37.6377 1.90476 37.3954 1.90476 37.1429V10.4762C1.90476 10.2236 2.0051 9.98136 2.18371 9.80275C2.36231 9.62415 2.60456 9.52381 2.85714 9.52381H7.61905V29.5238C7.61905 30.2816 7.92007 31.0083 8.45588 31.5441C8.9917 32.0799 9.71843 32.381 10.4762 32.381H38.0952V37.1429ZM44.7619 30.4762H10.4762C10.2236 30.4762 9.98136 30.3759 9.80275 30.1972C9.62415 30.0186 9.52381 29.7764 9.52381 29.5238V20.5571L18.3738 11.7071C18.4623 11.6186 18.5673 11.5483 18.6829 11.5004C18.7985 11.4525 18.9225 11.4278 19.0476 11.4278C19.1728 11.4278 19.2967 11.4525 19.4123 11.5004C19.5279 11.5483 19.633 11.6186 19.7214 11.7071L31.5452 23.531C31.7238 23.7091 31.9657 23.8091 32.2179 23.8091C32.47 23.8091 32.7119 23.7091 32.8905 23.531L39 17.4214C39.0885 17.3329 39.1935 17.2626 39.3091 17.2147C39.4247 17.1668 39.5487 17.1421 39.6738 17.1421C39.799 17.1421 39.9229 17.1668 40.0385 17.2147C40.1541 17.2626 40.2592 17.3329 40.3476 17.4214L45.7143 22.7881V29.5238C45.7143 29.7764 45.6139 30.0186 45.4353 30.1972C45.2567 30.3759 45.0145 30.4762 44.7619 30.4762ZM32.381 9.52381C32.381 9.14708 32.4927 8.77882 32.702 8.46558C32.9113 8.15234 33.2087 7.90821 33.5568 7.76404C33.9048 7.61987 34.2878 7.58215 34.6573 7.65565C35.0268 7.72914 35.3662 7.91055 35.6326 8.17694C35.899 8.44333 36.0804 8.78272 36.1539 9.15221C36.2274 9.5217 36.1897 9.90468 36.0455 10.2527C35.9013 10.6008 35.6572 10.8983 35.3439 11.1076C35.0307 11.3169 34.6624 11.4286 34.2857 11.4286C33.7805 11.4286 33.2961 11.2279 32.9388 10.8707C32.5816 10.5135 32.381 10.029 32.381 9.52381Z"
					fill={stroke}
					fillOpacity={strokeOpacity}
				/>
			</svg.SVG>
		)
	}

	Imagery.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const ToneOfVoice = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" {...rest}>
				<path
					d="M21 1V41M11 13.5V28.5M41 16V26M1 16V26M31 8.5V33.5"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg.SVG>
		)
	}

	ToneOfVoice.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Application = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...rest}>
				<rect
					x="1"
					y="1"
					width="38"
					height="27.8868"
					rx="2"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
				<line
					x1="9.66663"
					y1="29.8868"
					x2="9.66663"
					y2="40"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
				<line
					x1="31.6666"
					y1="29.8868"
					x2="31.6666"
					y2="40"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
				<mask id="path-4-inside-1_2003_1004" fill="white">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M23.3333 20.6667L16.7542 10L12.888 16.2683L10.4884 12.4381L5.33334 20.6666H10.1751L10.1751 20.6667H23.3333Z"
					/>
				</mask>
				<path
					d="M16.7542 10L18.4564 8.95007L16.7542 6.19023L15.052 8.95007L16.7542 10ZM23.3333 20.6667V22.6667H26.9167L25.0356 19.6167L23.3333 20.6667ZM12.888 16.2683L11.1931 17.3301L12.9012 20.0566L14.5902 17.3183L12.888 16.2683ZM10.4884 12.4381L12.1832 11.3763L10.4884 8.67089L8.79351 11.3763L10.4884 12.4381ZM5.33334 20.6666L3.63848 19.6048L1.72032 22.6666H5.33334V20.6666ZM10.1751 20.6666L11.8711 21.7266L13.7836 18.6666H10.1751V20.6666ZM10.1751 20.6667L8.4791 19.6067L6.5666 22.6667H10.1751V20.6667ZM15.052 11.0499L21.6311 21.7166L25.0356 19.6167L18.4564 8.95007L15.052 11.0499ZM14.5902 17.3183L18.4564 11.0499L15.052 8.95007L11.1857 15.2184L14.5902 17.3183ZM8.79351 13.4999L11.1931 17.3301L14.5828 15.2065L12.1832 11.3763L8.79351 13.4999ZM7.02821 21.7284L12.1832 13.4999L8.79351 11.3763L3.63848 19.6048L7.02821 21.7284ZM10.1751 18.6666H5.33334V22.6666H10.1751V18.6666ZM11.8711 21.7267L11.8711 21.7266L8.47912 19.6066L8.4791 19.6067L11.8711 21.7267ZM23.3333 18.6667H10.1751V22.6667H23.3333V18.6667Z"
					fill={stroke}
					fillOpacity={strokeOpacity}
					mask="url(#path-4-inside-1_2003_1004)"
				/>
				<line x1="25.3333" y1="11" x2="34" y2="11" stroke={stroke} strokeOpacity={strokeOpacity} strokeWidth="2" />
				<line
					x1="25.3333"
					y1="14.3333"
					x2="34"
					y2="14.3333"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
				<line
					x1="25.3333"
					y1="18.3333"
					x2="30.6667"
					y2="18.3333"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
			</svg.SVG>
		)
	}

	Application.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Archetype = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="47" height="43" viewBox="0 0 47 43" fill="none" {...rest}>
				<path
					d="M23.609 41.9512C23.3457 41.9512 23.0622 41.8691 22.8193 41.7255C21.9485 41.1922 1.43542 28.4537 1.43542 14.6281C1.43542 7.63322 7.10538 1.95117 14.0511 1.95117C17.7365 1.95117 21.2195 3.5922 23.609 6.36143C25.9782 3.5922 29.4814 1.95117 33.1669 1.95117C40.1329 1.95117 45.7826 7.63322 45.7826 14.6281C45.7826 28.4537 25.2695 41.1922 24.3987 41.7255C24.1557 41.8691 23.8925 41.9512 23.609 41.9512Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeMiterlimit="10"
				/>
			</svg.SVG>
		)
	}

	Archetype.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Compliance = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="35" height="42" viewBox="0 0 35 42" fill="none" {...rest}>
				<path
					d="M24.6364 4.63636H33.7273V41H1V4.63636H10.0909M10.0909 24.6364L15.5455 30.0909L26.4545 19.1818M10.0909 10.0909H24.6364V1H10.0909V10.0909Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
			</svg.SVG>
		)
	}

	Compliance.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export namespace imagery {
		export const Lifestyle = (props: svg.SVGProps) => {
			const { stroke, strokeOpacity, ...rest } = props
			return (
				<svg.SVG xmlns="http://www.w3.org/2000/svg" width="43" height="55" viewBox="0 0 43 55" fill="none" {...rest}>
					<path
						d="M41.7143 49.8571V5.07143C41.7143 3.99162 41.2853 2.95603 40.5218 2.19249C39.7583 1.42895 38.7227 1 37.6429 1H5.07143C3.99162 1 2.95603 1.42895 2.19249 2.19249C1.42895 2.95603 1 3.99162 1 5.07143V49.8571C1 50.9369 1.42895 51.9725 2.19249 52.7361C2.95603 53.4996 3.99162 53.9286 5.07143 53.9286H37.6429C38.7227 53.9286 39.7583 53.4996 40.5218 52.7361C41.2853 51.9725 41.7143 50.9369 41.7143 49.8571Z"
						stroke={stroke}
						strokeOpacity={strokeOpacity}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M1 30.7499C2.41279 30.5097 3.85 30.3916 5.28721 30.3957C10.2706 30.2939 15.136 31.7719 19.0079 34.5689C25.2861 39.0923 27.6556 46.9379 27.6556 53.9286M27.6556 21.3083C28.3125 21.3083 28.9629 21.1789 29.5697 20.9275C30.1766 20.6762 30.728 20.3078 31.1924 19.8433C31.6569 19.3788 32.0253 18.8275 32.2767 18.2206C32.528 17.6138 32.6574 16.9634 32.6574 16.3065C32.6574 15.6497 32.528 14.9993 32.2767 14.3924C32.0253 13.7856 31.6569 13.2342 31.1924 12.7698C30.728 12.3053 30.1766 11.9369 29.5697 11.6855C28.9629 11.4342 28.3125 11.3048 27.6556 11.3048C26.3291 11.3048 25.0569 11.8317 24.1189 12.7698C23.1809 13.7078 22.6539 14.98 22.6539 16.3065C22.6539 17.6331 23.1809 18.9053 24.1189 19.8433C25.0569 20.7813 26.3291 21.3083 27.6556 21.3083Z"
						stroke={stroke}
						strokeOpacity={strokeOpacity}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M41.7141 37.1136C38.9373 36.2835 36.0541 35.8638 33.1559 35.8677C29.4947 35.8569 25.8626 36.5179 22.4399 37.8179"
						stroke={stroke}
						strokeOpacity={strokeOpacity}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg.SVG>
			)
		}

		Lifestyle.defaultProps = {
			stroke: theme.colors.grey.dark50,
			strokeOpacity: "0.5",
		}
		export const Product = (props: svg.SVGProps) => {
			const { stroke, strokeOpacity, ...rest } = props
			return (
				<svg.SVG xmlns="http://www.w3.org/2000/svg" width="34" height="57" viewBox="0 0 34 57" fill="none" {...rest}>
					<path
						d="M7.66667 46.1041H26.3333M7.66667 46.1041V55.5833H26.3333V46.1041M7.66667 46.1041C7.66667 46.1041 3.66667 36.625 2.33333 24.4375C1 12.25 1 1.41663 1 1.41663H33C33 1.41663 33 12.25 31.6667 24.4375C30.3333 36.625 26.3333 46.1041 26.3333 46.1041"
						stroke={stroke}
						strokeOpacity={strokeOpacity}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M2.3335 9.54163H31.6668M12.5242 25.6413C14.4322 23.0955 15.9042 19.576 16.6988 17.6666C18.0908 19.576 21.1122 24.367 22.0668 26.9142C23.2588 30.0965 20.2775 33.9166 16.6988 33.9166C13.1202 33.9166 10.1388 28.825 12.5242 25.6413Z"
						stroke={stroke}
						strokeOpacity={strokeOpacity}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg.SVG>
			)
		}

		Product.defaultProps = {
			stroke: theme.colors.grey.dark50,
			strokeOpacity: "0.5",
		}

		export const Illustration = (props: svg.SVGProps) => {
			const { stroke, strokeOpacity, ...rest } = props
			return (
				<svg.SVG xmlns="http://www.w3.org/2000/svg" width="63" height="51" viewBox="0 0 63 51" fill="none" {...rest}>
					<path
						d="M1.33824 7.83926C1.09088 7.59042 0.952032 7.2538 0.952032 6.90293C0.952032 6.55206 1.09088 6.21544 1.33824 5.9666C1.57398 5.73418 7.16871 0.265625 18.2187 0.265625C23.933 0.265625 28.1531 3.08125 32.2371 5.80059C36.1484 8.41699 39.8705 10.8906 44.7812 10.8906C54.6658 10.8906 59.7226 6.01309 59.7824 5.96328C60.032 5.71451 60.3703 5.5751 60.7227 5.57573C61.0752 5.57635 61.4129 5.71695 61.6617 5.9666C61.9104 6.21625 62.0499 6.5545 62.0492 6.90694C62.0486 7.25937 61.908 7.59713 61.6584 7.8459C61.4259 8.07832 55.8312 13.5469 44.7812 13.5469C39.067 13.5469 34.8468 10.7313 30.7628 8.01191C26.8515 5.39551 23.1295 2.92188 18.2187 2.92188C8.33414 2.92188 3.2773 7.79941 3.21754 7.84922C3.09354 7.97205 2.94654 8.06924 2.78495 8.13522C2.62337 8.20121 2.45036 8.23469 2.27582 8.23377C2.10129 8.23284 1.92864 8.19752 1.76777 8.12983C1.60689 8.06214 1.46093 7.9634 1.33824 7.83926ZM59.7757 24.557C59.7226 24.6068 54.6658 29.4844 44.7812 29.4844C39.8705 29.4844 36.1484 27.0107 32.2371 24.3943C28.1531 21.675 23.933 18.8594 18.2187 18.8594C7.16871 18.8594 1.57398 24.3279 1.34156 24.5604C1.21795 24.6835 1.1198 24.8298 1.05274 24.991C0.985672 25.1521 0.950994 25.3248 0.950686 25.4993C0.950377 25.6738 0.984444 25.8467 1.05094 26.008C1.11744 26.1694 1.21506 26.316 1.33824 26.4396C1.46142 26.5633 1.60774 26.6614 1.76885 26.7285C1.92995 26.7955 2.10269 26.8302 2.2772 26.8305C2.45171 26.8308 2.62457 26.7968 2.78592 26.7303C2.94726 26.6638 3.09392 26.5661 3.21754 26.443C3.2773 26.3932 8.33414 21.5156 18.2187 21.5156C23.1295 21.5156 26.8515 23.9893 30.7628 26.6057C34.8468 29.325 39.0636 32.1406 44.7812 32.1406C55.8312 32.1406 61.4259 26.6721 61.6584 26.4396C61.908 26.1909 62.0486 25.8531 62.0492 25.5007C62.0499 25.1483 61.9104 24.81 61.6617 24.5604C61.4129 24.3107 61.0752 24.1701 60.7227 24.1695C60.3703 24.1689 60.032 24.3083 59.7824 24.557H59.7757ZM59.7757 43.1508C59.7226 43.2006 54.6658 48.0781 44.7812 48.0781C39.8705 48.0781 36.1484 45.6045 32.2371 42.9881C28.1531 40.2687 23.933 37.4531 18.2187 37.4531C7.16871 37.4531 1.57398 42.9217 1.34156 43.1541C1.09191 43.4029 0.951308 43.7406 0.950686 44.0931C0.950063 44.4455 1.08947 44.7837 1.33824 45.0334C1.58701 45.283 1.92477 45.4236 2.2772 45.4243C2.62964 45.4249 2.96789 45.2855 3.21754 45.0367C3.2773 44.9869 8.33414 40.1094 18.2187 40.1094C23.1295 40.1094 26.8515 42.583 30.7628 45.1994C34.8468 47.9188 39.0636 50.7344 44.7812 50.7344C55.8312 50.7344 61.4259 45.2658 61.6584 45.0334C61.782 44.9102 61.8801 44.7639 61.9472 44.6028C62.0142 44.4417 62.0489 44.2689 62.0492 44.0944C62.0495 43.9199 62.0155 43.7471 61.949 43.5857C61.8825 43.4244 61.7849 43.2777 61.6617 43.1541C61.5385 43.0305 61.3922 42.9323 61.2311 42.8653C61.07 42.7982 60.8972 42.7635 60.7227 42.7632C60.5482 42.7629 60.3753 42.797 60.214 42.8635C60.0527 42.93 59.906 43.0276 59.7824 43.1508H59.7757Z"
						stroke={stroke}
						fill={stroke}
						strokeOpacity={strokeOpacity}
						fillOpacity={strokeOpacity}
					/>
				</svg.SVG>
			)
		}

		Illustration.defaultProps = {
			stroke: theme.colors.grey.dark50,
			strokeOpacity: "0.5",
		}
	}
}

export namespace archetype {
	export namespace actions {
		export const Up = (props: svg.SVGProps) => {
			const { fill, fillOpacity, ...rest } = props
			return (
				<svg.SVG xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" fill="none" {...rest}>
					<path
						d="M9.15687 4.86563C9.20458 4.90856 9.2607 4.94211 9.32203 4.96438C9.38335 4.98665 9.44869 4.99721 9.5143 4.99544C9.57992 4.99367 9.64452 4.97962 9.70443 4.95408C9.76433 4.92855 9.81837 4.89202 9.86345 4.8466C9.90854 4.80118 9.94378 4.74775 9.96718 4.68937C9.99057 4.63098 10.0017 4.56878 9.9998 4.50631C9.99794 4.44384 9.98318 4.38234 9.95636 4.3253C9.92953 4.26827 9.89117 4.21682 9.84347 4.1739L5.34611 0.130042C5.25333 0.0465313 5.13049 -4.15657e-07 5.00281 -4.17179e-07C4.87513 -4.18702e-07 4.75229 0.0465313 4.65951 0.130042L0.16165 4.1739C0.112898 4.21653 0.07353 4.26797 0.045834 4.32521C0.018138 4.38246 0.00266565 4.44437 0.000315106 4.50736C-0.00203544 4.57035 0.00878345 4.63315 0.0321424 4.69212C0.0555014 4.75109 0.0909349 4.80506 0.136386 4.85088C0.181836 4.89671 0.236398 4.93348 0.296901 4.95906C0.357404 4.98464 0.422642 4.99851 0.488826 4.99989C0.555011 5.00126 0.620822 4.9901 0.682437 4.96705C0.744053 4.944 0.800244 4.90953 0.847747 4.86563L5.00281 1.13006L9.15687 4.86563Z"
						fill={fill}
						fillOpacity={fillOpacity}
					/>
				</svg.SVG>
			)
		}

		Up.defaultProps = {
			fill: theme.colors.white,
			fillOpacity: "0.75",
		}

		export const Down = (props: svg.SVGProps) => {
			const { fill, fillOpacity, ...rest } = props
			return (
				<svg.SVG xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" fill="none" {...rest}>
					<path
						d="M0.84313 0.134365C0.795423 0.0914442 0.739303 0.0578899 0.677975 0.0356175C0.616646 0.0133451 0.551311 0.00279089 0.485698 0.00455797C0.420085 0.00632505 0.355481 0.0203787 0.295573 0.0459162C0.235665 0.0714537 0.181627 0.107975 0.136545 0.153395C0.0914621 0.198815 0.0562172 0.252245 0.0328235 0.310633C0.00942896 0.369021 -0.00165655 0.431223 0.00020025 0.49369C0.0020561 0.556157 0.0168171 0.617664 0.0436411 0.674699C0.0704651 0.731735 0.108826 0.783181 0.156533 0.826103L4.65389 4.86996C4.74667 4.95347 4.86951 5 4.99719 5C5.12487 5 5.24771 4.95347 5.34049 4.86996L9.83835 0.826104C9.8871 0.783466 9.92647 0.73203 9.95417 0.674785C9.98186 0.61754 9.99733 0.555626 9.99968 0.49264C10.002 0.429654 9.99122 0.36685 9.96786 0.307878C9.9445 0.248906 9.90907 0.19494 9.86361 0.149116C9.81816 0.103292 9.7636 0.0665221 9.7031 0.0409429C9.6426 0.0153638 9.57736 0.00148506 9.51117 0.000112772C9.44499 -0.00125952 9.37918 0.00990186 9.31756 0.032949C9.25595 0.0559961 9.19976 0.0904694 9.15225 0.134366L4.99719 3.86994L0.84313 0.134365Z"
						fill={fill}
						fillOpacity={fillOpacity}
					/>
				</svg.SVG>
			)
		}

		Down.defaultProps = {
			fill: theme.colors.white,
			fillOpacity: "0.75",
		}
	}

	export const Everyman = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none" {...rest}>
				<path
					d="M39.9633 14C39.4526 20.6087 34.2316 26 28.5 26C22.7684 26 17.5383 20.61 17.0367 14C16.5157 7.125 21.596 2 28.5 2C35.404 2 40.4843 7.25 39.9633 14Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M28.4994 35C17.3982 35 6.13122 41 4.04625 52.325C3.79488 53.69 4.58344 55 6.0419 55H50.9568C52.4166 55 53.2051 53.69 52.9538 52.325C50.8675 41 39.6005 35 28.4994 35Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeMiterlimit="10"
				/>
			</svg.SVG>
		)
	}

	Everyman.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Caregiver = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="42" height="55" viewBox="0 0 42 55" fill="none" {...rest}>
				<path
					d="M38.5599 37.04C39.3308 36.3125 39.9447 35.4368 40.3642 34.466C40.7837 33.4953 41 32.4499 41 31.3935C41 30.337 40.7837 29.2916 40.3642 28.3209C39.9447 27.3502 39.3308 26.4744 38.5599 25.7469C36.9818 24.2586 34.8891 23.4289 32.7134 23.4289C30.5377 23.4289 28.445 24.2586 26.867 25.7469L21 31.5769L15.133 25.7469C13.555 24.2586 11.4623 23.4289 9.28658 23.4289C7.11091 23.4289 5.01821 24.2586 3.44013 25.7469C2.66922 26.4744 2.05533 27.3502 1.63583 28.3209C1.21633 29.2916 1 30.337 1 31.3935C1 32.4499 1.21633 33.4953 1.63583 34.466C2.05533 35.4368 2.66922 36.3125 3.44013 37.04L21 54L38.5599 37.04ZM21 17.3077C23.1762 17.3077 25.2634 16.4486 26.8022 14.9195C28.341 13.3903 29.2055 11.3164 29.2055 9.15385C29.2055 6.99131 28.341 4.91735 26.8022 3.38821C25.2634 1.85906 23.1762 1 21 1C18.8238 1 16.7366 1.85906 15.1978 3.38821C13.659 4.91735 12.7945 6.99131 12.7945 9.15385C12.7945 11.3164 13.659 13.3903 15.1978 14.9195C16.7366 16.4486 18.8238 17.3077 21 17.3077Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg.SVG>
		)
	}

	Caregiver.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Outlaw = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="61" height="53" viewBox="0 0 61 53" fill="none" {...rest}>
				<path
					d="M60.5819 18.2394C60.0908 17.7104 58.5711 17.5136 56.4061 17.5136C53.5678 17.5136 49.619 17.852 45.4156 18.2233C43.1985 11.3788 39.1267 0 36.5765 0C36.519 0 36.4649 0.00599696 36.4091 0.0171334C33.5541 0.604384 31.2457 4.78279 30.4737 4.78279C29.702 4.78279 27.3935 0.604384 24.5404 0.0171334C24.4846 0.00599696 24.4287 0 24.3729 0C21.8209 0 17.7514 11.3782 15.5324 18.2233C11.3306 17.8518 7.38001 17.5136 4.54184 17.5136C2.3767 17.5136 0.858926 17.7104 0.367885 18.2394C-1.10722 19.8247 1.53606 27.2184 14.1285 30.8457L28.7353 47.6754L25.7389 51.1267L27.5916 53L30.4745 49.6791L33.3575 53L35.2102 51.1267L32.2155 47.6754L46.8224 30.8457C59.4128 27.2186 62.0559 19.825 60.583 18.2394H60.5819ZM43.7449 21.4168C40.9306 22.1856 35.9643 23.279 30.4738 23.279C24.9834 23.279 20.0186 22.1857 17.2028 21.4168C17.3834 20.8415 17.5877 20.1939 17.8129 19.4923C19.3977 20.0665 23.7853 21.3947 30.4739 21.3947C36.649 21.3947 41.1709 20.2662 43.1852 19.648C43.3918 20.2894 43.5797 20.8848 43.7451 21.4168H43.7449ZM22.7679 6.29664C23.6793 4.36701 24.3099 3.41138 24.6652 2.9578C25.56 3.47672 26.5661 4.62832 27.2172 5.37319C27.5781 5.78675 27.8906 6.14313 28.203 6.44829C28.5062 6.74235 29.3079 7.52449 30.4741 7.52449C31.6403 7.52449 32.4438 6.74233 32.7452 6.44829C33.0577 6.1431 33.3702 5.78675 33.7328 5.37319C34.3838 4.62832 35.3901 3.47673 36.2829 2.9578C36.64 3.41162 37.2705 4.36723 38.182 6.29664C39.0952 8.22907 40.1108 10.7509 41.2028 13.7909C41.6026 14.9052 41.9822 16.0076 42.3337 17.0538C40.4085 17.6261 36.1602 18.653 30.4742 18.653C24.2168 18.653 20.0825 17.4091 18.6649 16.9062C19.0016 15.9044 19.3663 14.8532 19.7474 13.7912C20.837 10.7513 21.8543 8.22956 22.7678 6.29692L22.7679 6.29664ZM4.25684 22.4004C3.49418 21.5673 3.05535 20.8472 2.8115 20.3163C3.22437 20.2812 3.78622 20.255 4.54137 20.255C7.13803 20.255 10.7723 20.5542 14.6842 20.8986C14.2323 22.3614 13.968 23.2729 13.968 23.2729C13.968 23.2729 21.4844 26.0206 30.4738 26.0206C39.4632 26.0206 46.9817 23.2729 46.9817 23.2729C46.9817 23.2729 46.7177 22.3614 46.2637 20.8986C50.1771 20.5542 53.8096 20.255 56.4065 20.255C57.1634 20.255 57.7253 20.2812 58.1382 20.3163C57.8946 20.8474 57.4537 21.567 56.6928 22.4004C55.3927 23.827 52.8798 25.871 48.2967 27.5113C43.4607 29.243 37.4636 30.1224 30.4738 30.1224C23.4856 30.1224 17.4893 29.243 12.653 27.5113C8.07034 25.8708 5.55759 23.8268 4.25735 22.4004H4.25684ZM30.4738 45.6689L18.4919 31.8651C21.8994 32.4916 25.8702 32.8631 30.4738 32.8631C35.0793 32.8631 39.0483 32.4916 42.4578 31.8651L30.4738 45.6689Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
			</svg.SVG>
		)
	}

	Outlaw.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}

	export const Magician = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53" fill="none" {...rest}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M48.8917 1.64333C48.8917 1.20749 48.7185 0.789505 48.4104 0.48132C48.1022 0.173136 47.6842 0 47.2483 0C46.8125 0 46.3945 0.173136 46.0863 0.48132C45.7782 0.789505 45.605 1.20749 45.605 1.64333V4.10833H43.14C42.7042 4.10833 42.2862 4.28146 41.978 4.58965C41.6698 4.89783 41.4967 5.31582 41.4967 5.75166C41.4967 6.18749 41.6698 6.60548 41.978 6.91367C42.2862 7.22185 42.7042 7.39499 43.14 7.39499H45.605V9.85998C45.605 10.2958 45.7782 10.7138 46.0863 11.022C46.3945 11.3302 46.8125 11.5033 47.2483 11.5033C47.6842 11.5033 48.1022 11.3302 48.4104 11.022C48.7185 10.7138 48.8917 10.2958 48.8917 9.85998V7.39499H51.3567C51.7925 7.39499 52.2105 7.22185 52.5187 6.91367C52.8269 6.60548 53 6.18749 53 5.75166C53 5.31582 52.8269 4.89783 52.5187 4.58965C52.2105 4.28146 51.7925 4.10833 51.3567 4.10833H48.8917V1.64333ZM40.486 12.514C40.6773 12.7048 40.8291 12.9315 40.9327 13.181C41.0362 13.4306 41.0895 13.6981 41.0895 13.9683C41.0895 14.2385 41.0362 14.506 40.9327 14.7556C40.8291 15.0052 40.6773 15.2318 40.486 15.4227L36.3777 19.531C36.1867 19.7217 35.96 19.8729 35.7106 19.976C35.4612 20.0792 35.1939 20.1321 34.924 20.1319C34.6541 20.1318 34.3868 20.0784 34.1376 19.9749C33.8883 19.8715 33.6618 19.7199 33.4711 19.5289C33.0859 19.1432 32.8697 18.6203 32.8701 18.0752C32.8703 17.8053 32.9237 17.538 33.0271 17.2888C33.1306 17.0395 33.2821 16.813 33.4731 16.6223L37.5815 12.514C37.9667 12.1289 38.4891 11.9125 39.0337 11.9125C39.5784 11.9125 40.1008 12.1289 40.486 12.514ZM32.2694 20.7306C32.4607 20.9214 32.6125 21.1481 32.716 21.3977C32.8196 21.6472 32.8729 21.9148 32.8729 22.185C32.8729 22.4552 32.8196 22.7227 32.716 22.9723C32.6125 23.2218 32.4607 23.4485 32.2694 23.6393L3.51111 52.3976C3.32012 52.5886 3.09338 52.7401 2.84384 52.8434C2.59431 52.9468 2.32686 53 2.05676 53C1.78666 53 1.51921 52.9468 1.26967 52.8434C1.02013 52.7401 0.793398 52.5886 0.60241 52.3976C0.411422 52.2066 0.259923 51.9799 0.156562 51.7303C0.0531998 51.4808 0 51.2133 0 50.9432C0 50.6731 0.0531998 50.4057 0.156562 50.1562C0.259923 49.9066 0.411422 49.6799 0.60241 49.4889L29.3607 20.7306C29.5515 20.5393 29.7782 20.3875 30.0278 20.284C30.2773 20.1804 30.5448 20.1271 30.815 20.1271C31.0852 20.1271 31.3528 20.1804 31.6023 20.284C31.8519 20.3875 32.0786 20.5393 32.2694 20.7306ZM47.2483 20.5416C48.1522 20.5416 48.8917 21.2811 48.8917 22.185V24.65H51.3567C51.7925 24.65 52.2105 24.8231 52.5187 25.1313C52.8269 25.4395 53 25.8575 53 26.2933C53 26.7291 52.8269 27.1471 52.5187 27.4553C52.2105 27.7635 51.7925 27.9366 51.3567 27.9366H48.8917V30.4016C48.8917 30.8375 48.7185 31.2554 48.4104 31.5636C48.1022 31.8718 47.6842 32.0449 47.2483 32.0449C46.8125 32.0449 46.3945 31.8718 46.0863 31.5636C45.7782 31.2554 45.605 30.8375 45.605 30.4016V27.9366H43.14C42.7042 27.9366 42.2862 27.7635 41.978 27.4553C41.6698 27.1471 41.4967 26.7291 41.4967 26.2933C41.4967 25.8575 41.6698 25.4395 41.978 25.1313C42.2862 24.8231 42.7042 24.65 43.14 24.65H45.605V22.185C45.605 21.2811 46.3445 20.5416 47.2483 20.5416ZM28.35 1.64333C28.35 1.20749 28.1769 0.789505 27.8687 0.48132C27.5605 0.173136 27.1426 0 26.7067 0C26.2709 0 25.8529 0.173136 25.5447 0.48132C25.2365 0.789505 25.0634 1.20749 25.0634 1.64333V4.10833H22.5984C22.1625 4.10833 21.7446 4.28146 21.4364 4.58965C21.1282 4.89783 20.9551 5.31582 20.9551 5.75166C20.9551 6.18749 21.1282 6.60548 21.4364 6.91367C21.7446 7.22185 22.1625 7.39499 22.5984 7.39499H25.0634V9.85998C25.0634 10.2958 25.2365 10.7138 25.5447 11.022C25.8529 11.3302 26.2709 11.5033 26.7067 11.5033C27.1426 11.5033 27.5605 11.3302 27.8687 11.022C28.1769 10.7138 28.35 10.2958 28.35 9.85998V7.39499H30.815C31.2509 7.39499 31.6689 7.22185 31.9771 6.91367C32.2852 6.60548 32.4584 6.18749 32.4584 5.75166C32.4584 5.31582 32.2852 4.89783 31.9771 4.58965C31.6689 4.28146 31.2509 4.10833 30.815 4.10833H28.35V1.64333Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
			</svg.SVG>
		)
	}

	Magician.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}

	export const Hero = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="44" height="57" viewBox="0 0 44 57" fill="none" {...rest}>
				<path
					d="M43.0837 8.13555L22.0258 0.0474881C21.8616 -0.0158294 21.6793 -0.0158294 21.5151 0.0474881L0.45714 8.13555C0.181605 8.24131 0 8.50571 0 8.80072V32.4747C0 40.2065 4.19918 47.3422 10.9588 51.0971L21.4243 56.91C21.5314 56.9701 21.6511 57 21.7701 57C21.8891 57 22.0087 56.9701 22.1159 56.9102L32.5813 51.0973C39.3412 47.3426 43.5402 40.2068 43.5402 32.4749V8.80096C43.5402 8.50593 43.3586 8.2413 43.083 8.13554L43.0837 8.13555ZM42.1159 32.4751C42.1159 39.6898 38.1978 46.3481 31.8903 49.8518L21.7704 55.4722L11.6505 49.8516C5.34314 46.3475 1.42499 39.6895 1.42499 32.4749V9.29075L21.7704 1.47641L42.1159 9.29075V32.4751Z"
					fill={fill}
					fillOpacity={fillOpacity}
					strokeWidth="0"
				/>
				<path
					d="M21.1577 14.373L17.0191 21.3519L9.10204 23.1322C8.85712 23.1874 8.65882 23.3676 8.58089 23.607C8.50296 23.8464 8.55723 24.1087 8.72352 24.2977L14.0812 30.3908L13.3283 38.4699C13.3053 38.7204 13.416 38.9646 13.6191 39.1126C13.8223 39.2606 14.0874 39.29 14.3205 39.1905L21.7702 35.9769L29.22 39.1901C29.3112 39.229 29.4072 39.2483 29.5025 39.2483C29.6507 39.2483 29.7975 39.2021 29.9214 39.1121C30.1246 38.9644 30.2352 38.7199 30.2122 38.4694L29.4594 30.3903L34.817 24.2972C34.9833 24.1084 35.0376 23.8459 34.9596 23.6065C34.8817 23.3672 34.6834 23.187 34.4385 23.1318L26.5214 21.3515L22.3828 14.3725C22.1254 13.9402 21.4143 13.9402 21.1568 14.373L21.1577 14.373ZM25.4536 22.3429C25.5538 22.5115 25.7187 22.6314 25.9101 22.6743L32.9543 24.2587L28.1867 29.6803C28.0573 29.8276 27.9939 30.0215 28.012 30.2168L28.6821 37.4053L22.0535 34.5463C21.963 34.5076 21.867 34.4883 21.771 34.4883C21.6749 34.4883 21.5789 34.5078 21.4885 34.5465L14.8598 37.4056L15.5299 30.217C15.548 30.0217 15.4847 29.8279 15.3552 29.6806L10.5876 24.2589L17.6319 22.6746C17.8232 22.6314 17.9881 22.5117 18.0883 22.3431L21.7712 16.1331L25.4536 22.3429Z"
					fill={fill}
					fillOpacity={fillOpacity}
					strokeWidth="0"
				/>
			</svg.SVG>
		)
	}

	Hero.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}

	export const Jester = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="72" height="53" viewBox="0 0 72 53" fill="none" {...rest}>
				<path
					d="M3.58177 28.9091C5.55709 28.9091 7.16418 27.288 7.16418 25.2955C7.16418 23.8979 6.37331 22.6841 5.21949 22.0833C6.9714 19.8526 9.91916 16.8636 13.1352 16.8636C15.6127 16.8636 16.7176 17.9781 16.7176 20.4773V44.5682C16.7176 46.1383 17.7159 47.4774 19.1059 47.9745V51.7955C19.1059 52.4607 19.6405 53 20.3 53H51.3475C52.007 53 52.5417 52.4607 52.5417 51.7955V47.9745C53.9316 47.4774 54.9299 46.1386 54.9299 44.5682V20.4773C54.9299 17.9781 56.0348 16.8636 58.5123 16.8636C61.728 16.8636 64.6755 19.8529 66.428 22.0833C65.2742 22.6841 64.4833 23.8979 64.4833 25.2955C64.4833 27.288 66.0904 28.9091 68.0657 28.9091C70.0411 28.9091 71.6481 27.288 71.6481 25.2955C71.6481 24.2277 71.1864 23.2671 70.454 22.605V18.0682C70.454 8.10547 62.4186 0 52.542 0C44.9301 0 38.4136 4.81465 35.8241 11.5829C33.2348 4.81497 26.7181 0 19.1062 0C9.22956 0 1.19414 8.10547 1.19414 18.0682V22.605C0.461733 23.2671 0 24.2279 0 25.2955C0 27.288 1.60708 28.9091 3.58241 28.9091H3.58177ZM50.1531 50.5909H21.4938V48.1818H50.1531V50.5909ZM52.5413 40.747C51.1514 40.2499 50.1531 38.9109 50.1531 37.3407C50.1531 35.7706 51.1514 34.4315 52.5413 33.9344V40.747ZM69.2592 25.2955C69.2592 25.9597 68.7236 26.5 68.0651 26.5C67.4066 26.5 66.871 25.9597 66.871 25.2955C66.871 24.6312 67.4066 24.0909 68.0651 24.0909C68.7236 24.0909 69.2592 24.6312 69.2592 25.2955ZM37.0176 18.0682C37.0176 9.43336 43.9811 2.40909 52.5413 2.40909C61.1015 2.40909 68.0651 9.43336 68.0651 18.0682V20.2881C65.8699 17.5623 62.4944 14.4545 58.512 14.4545C54.7174 14.4545 52.5413 16.6498 52.5413 20.4773V21.2592L44.2461 31.7185L37.0176 21.3023V18.0682ZM43.2042 34.4179C43.4199 34.7285 43.7682 34.9188 44.1444 34.9311C44.5188 34.9406 44.88 34.776 45.1151 34.4796L52.5417 25.1156V31.4393C49.8198 31.9989 47.7651 34.4323 47.7651 37.3408C47.7651 40.2492 49.8198 42.6827 52.5417 43.2423V44.5681C52.5417 45.2323 52.006 45.7726 51.3475 45.7726H20.3C19.6415 45.7726 19.1059 45.2323 19.1059 44.5681V43.2423C21.828 42.6827 23.8824 40.2492 23.8824 37.3408C23.8824 34.4323 21.828 31.9989 19.1059 31.4393V25.1156L26.5324 34.4796C26.7675 34.776 27.13 34.9421 27.5031 34.9311C27.879 34.9188 28.2276 34.7288 28.4433 34.4179L35.824 23.7819L43.2042 34.4179ZM19.1056 40.747V33.9341C20.4955 34.4313 21.4939 35.7703 21.4939 37.3405C21.4939 38.9109 20.4955 40.2499 19.1056 40.747ZM3.58183 18.0682C3.58183 9.43336 10.5454 2.40909 19.1056 2.40909C27.6658 2.40909 34.6294 9.43336 34.6294 18.0682V21.3021L27.4009 31.7184L19.1056 21.2591V20.4771C19.1056 16.6497 16.9293 14.4544 13.1349 14.4544C9.15224 14.4544 5.77713 17.5621 3.58183 20.2877V18.0682ZM3.58183 24.0909C4.24036 24.0909 4.77597 24.6312 4.77597 25.2955C4.77597 25.9597 4.24035 26.5 3.58183 26.5C2.92332 26.5 2.3877 25.9597 2.3877 25.2955C2.3877 24.6312 2.92332 24.0909 3.58183 24.0909ZM35.8235 43.3636C39.1158 43.3636 41.7942 40.6619 41.7942 37.3409C41.7942 34.0199 39.1158 31.3182 35.8235 31.3182C32.5312 31.3182 29.8528 34.0199 29.8528 37.3409C29.8528 40.6619 32.5312 43.3636 35.8235 43.3636ZM35.8235 33.7273C37.7988 33.7273 39.4059 35.3484 39.4059 37.3409C39.4059 39.3335 37.7988 40.9545 35.8235 40.9545C33.8482 40.9545 32.2411 39.3335 32.2411 37.3409C32.2411 35.3484 33.8482 33.7273 35.8235 33.7273Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
			</svg.SVG>
		)
	}

	Jester.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}

	export const Ruler = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="71" height="53" viewBox="0 0 71 53" fill="none" {...rest}>
				<path
					d="M39.3654 15.3277L42.7544 22.9784L48.1165 13.5617C48.3092 13.223 48.6332 12.9603 49.0389 12.8552C49.8358 12.6509 50.6502 13.1267 50.8545 13.9236L53.791 25.2172L56.1992 23.1856C55.9919 22.8324 55.8109 22.4617 55.6621 22.0764C55.3322 21.224 55.1513 20.3046 55.1513 19.3559C55.1513 17.2746 55.9978 15.386 57.3609 14.0199L57.4485 13.9382C58.8058 12.6217 60.6593 11.8073 62.6968 11.8073C64.781 11.8073 66.6666 12.6538 68.0328 14.0199L68.1145 14.1074C69.431 15.4677 70.2454 17.3183 70.2454 19.3558C70.2454 21.437 69.3988 23.3256 68.0328 24.6917C66.7484 25.9761 65 26.8022 63.0618 26.8956L60.2011 51.6748C60.1135 52.4366 59.4656 53 58.7183 52.9971L11.5212 53C10.7243 53 10.0705 52.3753 10.0296 51.5872L7.18069 26.8951C5.24541 26.8017 3.49694 25.9786 2.21258 24.6913C0.846461 23.3252 0 21.4366 0 19.3553C0 17.277 0.846523 15.3914 2.21551 14.0223C3.5787 12.6533 5.46728 11.8068 7.54853 11.8068C9.62685 11.8068 11.5125 12.6533 12.8786 14.0165C14.2505 15.3826 15.0941 17.2712 15.0941 19.3524C15.0941 20.3011 14.9132 21.2206 14.5833 22.0729C14.4344 22.4582 14.2535 22.829 14.0462 23.1821L16.4544 25.2137L19.388 13.9201C19.5923 13.1232 20.4067 12.6445 21.2036 12.8518C21.6093 12.9569 21.9333 13.2196 22.1259 13.5582L27.491 22.9749L30.88 15.3217C29.8875 14.7263 29.0293 13.9294 28.3667 12.9865C27.4239 11.6438 26.8693 10.0092 26.8693 8.25195C26.8693 5.97803 27.7946 3.91727 29.2862 2.42275C30.7778 0.925298 32.8415 0 35.1183 0C37.3893 0 39.453 0.925298 40.9475 2.41982C42.442 3.90849 43.3673 5.97224 43.3673 8.24903C43.3673 10.0063 42.8127 11.6409 41.8699 12.9836C41.2102 13.9235 40.352 14.7234 39.3596 15.3188L39.3654 15.3277ZM16.6293 44.8564C15.8032 44.8564 15.1348 44.1879 15.1348 43.3618C15.1348 42.5357 15.8032 41.8673 16.6293 41.8673H33.6296V40.2502C33.6296 39.4241 34.298 38.7557 35.1241 38.7557C35.9502 38.7557 36.6186 39.4241 36.6186 40.2502V41.8673H53.6188C54.4449 41.8673 55.1133 42.5357 55.1133 43.3618C55.1133 44.1879 54.4449 44.8564 53.6188 44.8564H36.6186V46.4764C36.6186 47.3025 35.9502 47.9709 35.1241 47.9709C34.298 47.9709 33.6296 47.3025 33.6296 46.4764V44.8564H16.6293ZM44.2581 26.3679L46.4824 31.3914L51.2695 27.3486L48.8964 18.2208L44.2552 26.3672L44.2581 26.3679ZM18.9826 27.3516L23.7697 31.3944L25.997 26.3708L21.3558 18.2244L18.9826 27.3516ZM44.5589 34.4157L36.0177 15.1151C35.7404 14.3416 36.1432 13.4893 36.9168 13.212C37.9384 12.8442 38.8171 12.1612 39.4388 11.2767C40.0342 10.4273 40.3874 9.3852 40.3874 8.25845C40.3874 6.80478 39.7978 5.48836 38.8462 4.53964C37.9004 3.58807 36.584 2.99842 35.1274 2.99842C33.6737 2.99842 32.3573 3.58806 31.4086 4.53964C30.457 5.48829 29.8703 6.80478 29.8703 8.25845C29.8703 9.3852 30.2235 10.4273 30.8189 11.2767C31.4202 12.1349 32.2697 12.8034 33.2534 13.1799L33.4373 13.247C34.1904 13.5798 34.5348 14.4613 34.202 15.2144L25.6957 34.4184C25.6373 34.5469 25.5643 34.6695 25.468 34.7804C24.9368 35.408 23.9939 35.4868 23.3663 34.9555L11.0247 24.535C10.4146 23.9803 10.3708 23.0375 10.9254 22.4274C11.3049 22.0129 11.6085 21.5283 11.8099 21.003C12.0025 20.5038 12.1105 19.9463 12.1105 19.3566C12.1105 18.0985 11.5997 16.9572 10.7766 16.134C9.95631 15.3109 8.81499 14.8001 7.55399 14.8001C6.29591 14.8001 5.15459 15.3109 4.33142 16.134C3.50532 16.9543 2.99743 18.0956 2.99743 19.3566C2.99743 20.6147 3.50825 21.756 4.33142 22.5792C5.15458 23.4024 6.29591 23.9132 7.55399 23.9132C7.83713 23.9015 8.05897 23.8927 8.33917 23.849C9.15649 23.7555 9.8979 24.3452 9.99131 25.1625L12.8577 50.009H57.3958L60.2739 25.0953C60.4053 24.2838 61.173 23.7321 61.9845 23.8635C62.2443 23.8927 62.4369 23.9072 62.7025 23.916C63.9606 23.916 65.1019 23.4052 65.9251 22.582C66.7483 21.7589 67.2591 20.6175 67.2591 19.3594C67.2591 18.1306 66.7746 17.0125 65.9922 16.2011L65.9251 16.1398C65.1019 15.3166 63.9606 14.8058 62.7025 14.8058C61.4737 14.8058 60.3586 15.2903 59.5412 16.0727L59.4799 16.1369C58.6568 16.96 58.146 18.1014 58.146 19.3594C58.146 19.9491 58.254 20.5037 58.4466 21.0058C58.648 21.5312 58.9545 22.0158 59.3311 22.4302L59.3661 22.4711C59.8973 23.0987 59.8185 24.0415 59.191 24.5728L46.9315 34.9236C46.8147 35.0287 46.6805 35.1192 46.5287 35.1863C45.7756 35.5191 44.894 35.1746 44.5613 34.4216L44.5589 34.4157Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
			</svg.SVG>
		)
	}

	Ruler.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}

	export const Creator = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none" {...rest}>
				<path
					d="M53.0354 23.1469L46.2267 22.0339V22.0304C45.8309 20.6665 45.2833 19.3521 44.6013 18.1084L48.5763 12.4445C48.7324 12.2227 48.8052 11.953 48.7819 11.6828C48.7586 11.4127 48.6408 11.1594 48.4491 10.9675L43.9689 6.48727C43.7749 6.29358 43.5181 6.17543 43.2448 6.15405C42.9715 6.13268 42.6996 6.20949 42.4778 6.37067L36.9022 10.381C35.6443 9.68493 34.3193 9.13373 32.9449 8.738L31.7577 1.954C31.6587 1.4028 31.1817 1 30.6199 1H24.2847C24.0114 0.999718 23.747 1.09657 23.5386 1.27327C23.3302 1.44997 23.1914 1.695 23.1469 1.9646L22.0445 8.71327C20.668 9.10641 19.3396 9.65154 18.0837 10.3386L12.5187 6.3636C12.2967 6.20523 12.0257 6.13073 11.754 6.15338C11.4823 6.17602 11.2274 6.29434 11.0347 6.48727L6.55087 10.964C6.35958 11.1552 6.24165 11.4076 6.21775 11.6769C6.19384 11.9463 6.26549 12.2155 6.42013 12.4374L10.3421 18.0413C9.64253 19.3062 9.0878 20.6383 8.68147 22.0269L1.9646 23.1469C1.40633 23.2388 1 23.7193 1 24.2847V30.6199C0.999982 30.8905 1.09522 31.1525 1.26901 31.3598C1.4428 31.5672 1.68406 31.7068 1.95047 31.7541L8.66733 32.9449C9.0708 34.3322 9.6278 35.6702 10.328 36.934L6.36007 42.4813C6.20238 42.7036 6.1283 42.9744 6.15093 43.2459C6.17356 43.5175 6.29144 43.7723 6.48373 43.9653L10.9675 48.4456C11.1589 48.6378 11.412 48.7563 11.6822 48.7802C11.9523 48.8041 12.2223 48.7319 12.4445 48.5763L18.0554 44.6437C19.3133 45.3363 20.644 45.8873 22.0233 46.2867L23.1505 53.0389C23.1949 53.3076 23.3333 53.5517 23.5411 53.7278C23.7488 53.9038 24.0124 54.0003 24.2847 54H30.6164C30.8876 54.0008 31.1504 53.906 31.3585 53.7321C31.5666 53.5583 31.7067 53.3165 31.7541 53.0495L32.9555 46.262C34.3293 45.8585 35.6541 45.3039 36.9057 44.6084L42.5591 48.5763C42.7812 48.7319 43.0512 48.8041 43.3214 48.7802C43.5915 48.7563 43.8446 48.6378 44.036 48.4456L48.5163 43.9653C48.7105 43.7718 48.8293 43.5153 48.8513 43.242C48.8733 42.9686 48.7971 42.6964 48.6364 42.4743L44.6049 36.8775C45.2903 35.6373 45.8345 34.3193 46.2267 32.9519L53.046 31.7541C53.3131 31.7076 53.5551 31.5683 53.7296 31.3608C53.9041 31.1534 53.9999 30.891 54 30.6199V24.2847C54.0003 24.0114 53.9034 23.747 53.7267 23.5386C53.55 23.3302 53.305 23.1914 53.0354 23.1469Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
				<path
					d="M19.2403 30.943V16.9H35.7598V30.943M30.2533 16.9V22.5172M24.7468 16.9V19.7086M30.2533 42.0369V36.5601H34.3831C35.1133 36.5601 35.8136 36.2642 36.33 35.7375C36.8463 35.2108 37.1364 34.4964 37.1364 33.7516V30.943H17.8636V33.7516C17.8636 35.2963 19.1026 36.5601 20.6169 36.5601H24.7468V42.0369C24.7468 42.7818 25.0368 43.4961 25.5532 44.0229C26.0695 44.5496 26.7698 44.8455 27.5 44.8455C28.2302 44.8455 28.9305 44.5496 29.4469 44.0229C29.9632 43.4961 30.2533 42.7818 30.2533 42.0369Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg.SVG>
		)
	}

	Creator.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Innocent = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53" fill="none" {...rest}>
				<path
					d="M1.05164 9.93686C5.61544 12.6883 10.1262 15.1665 14.5891 16.4387C19.4389 17.8212 24.2854 17.7948 29.112 15.1604L29.1121 15.1604C30.1658 14.5852 31.3193 13.6411 32.4811 12.6104C33.0696 12.0884 33.6767 11.5289 34.2888 10.9644L34.3266 10.9295C34.9289 10.3742 35.5368 9.81357 36.1498 9.26623C37.4059 8.14481 38.6518 7.1083 39.8488 6.33173C41.0593 5.54641 42.1276 5.08888 43.0356 5.01291L43.0357 5.0129C44.6706 4.87595 46.6329 5.84281 48.4618 7.18942C49.5984 8.02634 50.5952 8.94316 51.3057 9.64862C49.2882 10.3564 47.8391 11.5221 46.7868 12.9856C45.5473 14.7095 44.8996 16.7902 44.4417 18.8513C44.2287 19.8097 44.052 20.7886 43.8802 21.7401C43.8665 21.8157 43.8529 21.8912 43.8393 21.9665C43.6529 22.9974 43.469 23.9938 43.2427 24.9452C42.7872 26.8605 42.1844 28.4769 41.1668 29.6751C38.0277 33.3709 33.9453 35.1291 29.6354 36.5481C28.7751 36.8314 27.8988 37.1024 27.0177 37.3749C23.5683 38.4416 20.0456 39.531 17.1271 41.466L17.127 41.4661C15.6924 42.4174 13.8481 44.096 12.1035 46.0303C10.6283 47.6659 9.18356 49.5294 8.09152 51.3584L1.72369 41.7715C7.70755 40.8763 12.9195 38.1056 19.0963 31.385L20.6373 29.7083H18.3601C10.0843 29.7083 1.81928 21.8672 1.05164 9.93686ZM7.58584 52.4045L7.88821 52.8597C8.01822 53.0556 8.29775 53.045 8.40742 52.8364L7.58584 52.4045Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
				<path
					d="M16.8765 1.99886C15.8583 4.92868 15.764 8.04542 16.4032 10.8859C17.8686 11.2737 19.2775 11.4994 20.6293 11.5L16.8765 1.99886ZM16.8765 1.99886C18.7928 5.59961 21.5915 8.34381 24.9691 10.6975M16.8765 1.99886L24.9691 10.6975M24.9691 10.6975C23.5718 11.238 22.1422 11.5 20.6297 11.5L24.9691 10.6975Z"
					stroke={stroke}
					strokeOpacity={strokeOpacity}
					strokeWidth="2"
				/>
			</svg.SVG>
		)
	}

	Innocent.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.5",
	}

	export const Sage = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="39" height="53" viewBox="0 0 39 53" fill="none" {...rest}>
				<path
					d="M33.148 3.92199C34.4494 3.52479 35.8027 3.32324 37.1633 3.32384C37.486 3.32384 37.7844 3.1517 37.9458 2.87213C38.1071 2.59276 38.1071 2.24828 37.9458 1.96873C37.7844 1.68935 37.486 1.51702 37.1633 1.51702C35.1899 1.51702 33.2346 1.89403 31.4026 2.62766C28.7445 0.912392 25.6479 0 22.4844 0C19.3212 0 16.2248 0.912442 13.5668 2.62766C11.7347 1.89404 9.77927 1.51702 7.80557 1.51702C7.48267 1.51702 7.18448 1.68935 7.02312 1.96873C6.86177 2.2483 6.86177 2.59278 7.02312 2.87213C7.18447 3.1517 7.48266 3.32384 7.80557 3.32384C9.16615 3.32305 10.5195 3.52499 11.8209 3.9226C9.24109 6.10684 7.39427 9.03087 6.53046 12.2987C5.66645 15.5667 5.82681 19.021 6.99001 22.195C8.15339 25.3689 10.2631 28.1093 13.0343 30.0451C15.8055 31.9809 19.1042 33.0191 22.4845 33.0191C25.8647 33.0191 29.1636 31.9809 31.9346 30.0451C34.7058 28.1093 36.8155 25.3691 37.9789 22.195C39.1423 19.021 39.3026 15.5665 38.4386 12.2987C37.5746 9.03051 35.7278 6.10633 33.1482 3.9226L33.148 3.92199ZM22.4847 1.80677C24.9203 1.80382 27.3178 2.41004 29.4591 3.57027C26.2212 5.41688 23.748 8.35788 22.4847 11.8646C21.2218 8.35697 18.7488 5.41523 15.5104 3.56776C17.6519 2.40828 20.0495 1.8029 22.4847 1.80661V1.80677ZM22.4847 31.1976C19.3903 31.199 16.3742 30.2231 13.8667 28.409C11.3596 26.5949 9.48927 24.0355 8.52258 21.0959C7.55603 18.1561 7.54273 14.9864 8.48415 12.0383C9.4258 9.09044 11.2744 6.51493 13.7661 4.68C16.1053 5.80495 18.0798 7.56725 19.4626 9.76418C20.8451 11.9611 21.5795 14.5038 21.5813 17.0994V23.8704C21.5813 24.1931 21.7536 24.4913 22.033 24.6526C22.3126 24.814 22.6571 24.814 22.9364 24.6526C23.216 24.4913 23.3881 24.1931 23.3881 23.8704V17.0994C23.3905 14.504 24.1251 11.962 25.5075 9.76519C26.89 7.5686 28.8643 5.8067 31.2035 4.68201C33.6939 6.51764 35.5415 9.0928 36.4824 12.0403C37.4232 14.9877 37.4093 18.1568 36.443 21.0959C35.4766 24.0351 33.6069 26.5942 31.1003 28.4085C28.5938 30.2224 25.5785 31.1987 22.4848 31.1983L22.4847 31.1976Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
				<path
					d="M13.0657 13.1086C12.743 13.1086 12.4448 13.2808 12.2835 13.5603C12.1221 13.8399 12.1221 14.1842 12.2835 14.4638C12.4448 14.7433 12.743 14.9155 13.0657 14.9155C13.6017 14.916 14.1156 15.1292 14.4946 15.5081C14.8735 15.8871 15.0868 16.4008 15.0876 16.9368C15.0876 17.2595 15.2597 17.5577 15.5393 17.719C15.8189 17.8804 16.1632 17.8804 16.4427 17.719C16.7223 17.5577 16.8944 17.2595 16.8944 16.9368C16.8932 15.9218 16.4894 14.9488 15.7716 14.2311C15.0539 13.5135 14.0807 13.1098 13.0657 13.1087V13.1086Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
				<path
					d="M31.9018 13.1087C30.8868 13.1099 29.9138 13.5135 29.1961 14.2311C28.4783 14.9488 28.0744 15.9219 28.0731 16.9368C28.0731 17.2595 28.2454 17.5577 28.5248 17.719C28.8044 17.8804 29.1488 17.8804 29.4282 17.719C29.7078 17.5577 29.8799 17.2595 29.8799 16.9368C29.8809 16.4008 30.094 15.8871 30.4731 15.5081C30.8521 15.1292 31.366 14.9161 31.9018 14.9155C32.2245 14.9155 32.5229 14.7433 32.6842 14.4638C32.8456 14.1842 32.8456 13.8399 32.6842 13.5603C32.5229 13.2808 32.2245 13.1086 31.9018 13.1086V13.1087Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
				<path
					d="M34.6205 30.0927C34.381 30.0927 34.1512 30.188 33.9818 30.3574C33.8124 30.5268 33.7171 30.7565 33.7171 30.9961C33.7108 36.1691 31.7227 41.1429 28.1611 44.8946C24.5999 48.6464 19.7364 50.8907 14.5704 51.1662C17.9889 49.1263 22.3603 44.7129 21.6541 35.6085C21.6415 35.3652 21.5314 35.1372 21.3482 34.9762C21.1651 34.8155 20.925 34.7353 20.6821 34.7543C20.4392 34.7731 20.2141 34.8892 20.058 35.0764C19.902 35.2637 19.8283 35.5058 19.8534 35.7483C20.8056 48.0347 11.8497 50.651 10.5342 50.9677C10.2493 50.9256 9.96802 50.8713 9.68625 50.8177C4.86808 43.9754 9.95661 29.9596 10.0097 29.817L10.0095 29.8172C10.1215 29.5143 10.0635 29.1749 9.85741 28.9266C9.65116 28.6782 9.32806 28.5586 9.00986 28.6131C8.69167 28.6674 8.42681 28.8873 8.31484 29.1903C8.10095 29.7672 3.54118 42.3238 7.24892 50.2025L7.24872 50.2023C5.16291 49.522 3.20241 48.5047 1.44533 47.191C1.18713 46.9975 0.845219 46.9563 0.548399 47.0829C0.251574 47.2098 0.0451507 47.4852 0.00650494 47.8058C-0.0321173 48.1261 0.103159 48.4429 0.361358 48.6364C4.74585 51.9054 10.1904 53.4244 15.634 52.8976C21.0775 52.3708 26.1296 49.8359 29.8064 45.7868C33.4833 41.7377 35.52 36.4651 35.52 30.996C35.5198 30.757 35.4249 30.528 35.2563 30.3586C35.0875 30.1895 34.8585 30.0942 34.6195 30.0932L34.6205 30.0927Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
			</svg.SVG>
		)
	}

	Sage.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}

	export const Explorer = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none" {...rest}>
				<path
					d="M56.2875 27.6092L41.0578 24.6702L44.175 13.8936C44.264 13.5373 44.175 13.2702 43.9079 13.0029C43.6408 12.7357 43.3735 12.6466 43.0172 12.7357L32.2406 15.853L29.3907 0.71238C29.3015 0.267122 28.9452 0 28.5 0C28.0547 0 27.6984 0.267117 27.6092 0.712576L24.6702 15.9423L13.8936 12.8251C13.5373 12.7361 13.2702 12.8251 13.0029 13.0922C12.7357 13.3593 12.6466 13.6266 12.7357 13.9829L15.853 24.7595L0.71238 27.6092C0.267122 27.6984 0 28.0547 0 28.5C0 28.9452 0.267117 29.3015 0.712576 29.3907L15.9423 32.3297L12.8251 43.1063C12.647 43.8189 13.2703 44.4423 13.8937 44.175L24.6703 41.0577L27.6092 56.2875C27.6981 56.7327 28.0544 57 28.4999 57C28.9452 57 29.3014 56.7329 29.3906 56.2875L32.3297 41.0577L43.1063 44.175C43.9078 44.4421 44.5312 43.6405 44.1749 42.9282L41.0577 32.3299L56.2874 29.3908C56.7327 29.3019 57 28.9456 57 28.5001C56.9998 28.0548 56.7327 27.6986 56.2874 27.6094L56.2875 27.6092ZM42.0375 14.9624L39.2766 24.314L35.3578 23.6015C35.2688 23.6015 35.0907 23.5125 35.0015 23.5125C34.2 23.2454 33.5766 22.5328 33.3984 21.6421L32.6859 17.7233L42.0375 14.9624ZM17.7236 24.4032L14.9627 15.0516L24.3143 17.8125L23.6017 21.7312C23.4236 22.7109 22.622 23.5125 21.6423 23.6906L17.7236 24.4032ZM24.4031 39.2768L15.0515 42.0377L17.8124 32.6861L21.7311 33.3987C22.7108 33.5768 23.5124 34.3784 23.6905 35.3581L24.4031 39.2768ZM39.2767 32.5973L42.0376 41.9489L32.686 39.188L33.3986 35.2693C33.5767 34.2896 34.3783 33.488 35.358 33.3099L39.2767 32.5973ZM35.0017 31.6176C33.3094 31.9739 31.9737 33.3099 31.6174 35.0019L30.7266 39.7222L28.5002 51.3893L25.3829 35.0016C25.0267 33.3093 23.6907 31.9736 21.9986 31.6173L5.61088 28.5L21.9986 25.3828C23.6909 25.0265 25.0266 23.6906 25.3829 21.9985L28.5002 5.61077L30.7266 17.2779L31.6174 21.9982C31.9737 23.6904 33.3096 25.0262 35.0017 25.3825L51.3894 28.4997L35.0017 31.6176Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
				<path
					d="M28.4987 22.8887C25.3815 22.8887 22.8876 25.3825 22.8876 28.4998C22.8876 31.6172 25.3814 34.111 28.4987 34.111C31.6161 34.111 34.1099 31.6172 34.1099 28.4998C34.1099 25.3825 31.6161 22.8887 28.4987 22.8887ZM28.4987 32.3294C26.3612 32.3294 24.6689 30.6372 24.6689 28.4996C24.6689 26.3621 26.3612 24.6698 28.4987 24.6698C30.6363 24.6698 32.3285 26.3621 32.3285 28.4996C32.3285 30.6372 30.6363 32.3294 28.4987 32.3294Z"
					fill={fill}
					fillOpacity={fillOpacity}
				/>
			</svg.SVG>
		)
	}

	Explorer.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}

	export const Lover = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props

		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57" width="57" height="57" {...rest}>
				<path
					fill={fill}
					fillOpacity={fillOpacity}
					strokeWidth="0px"
					d="M28.5 49.675c-0.234 0 -0.456 -0.097 -0.621 -0.268l-19.722 -20.748c-1.624 -1.71 -2.742 -4.018 -3.141 -6.498 -0.399 -2.468 -0.074 -5.067 0.906 -7.319l0.427 -0.992c1.579 -3.614 4.628 -6.031 8.162 -6.458 3.545 -0.433 6.994 1.208 9.205 4.383L28.5 18.639l4.782 -6.857c1.972 -2.827 4.925 -4.452 8.105 -4.452 1.944 0 3.836 0.616 5.478 1.784 1.63 1.157 2.935 2.793 3.785 4.742l0.433 0.992c0.98 2.246 1.3 4.845 0.901 7.319 -0.399 2.479 -1.51 4.782 -3.141 6.498l-19.728 20.748c-0.16 0.171 -0.388 0.268 -0.621 0.268Zm-12.876 -40.641c-0.302 0 -0.604 0.017 -0.906 0.057 -2.924 0.353 -5.472 2.394 -6.8 5.444l-0.427 0.992c-0.849 1.955 -1.129 4.212 -0.787 6.361 0.342 2.143 1.3 4.127 2.69 5.592L28.5 47.578l19.106 -20.098c1.391 -1.465 2.348 -3.448 2.69 -5.592 0.348 -2.149 0.068 -4.412 -0.781 -6.361l-0.433 -0.992c-0.724 -1.664 -1.835 -3.055 -3.209 -4.03 -1.351 -0.958 -2.907 -1.465 -4.492 -1.465 -2.611 0 -5.056 1.357 -6.703 3.722l-5.483 7.866a0.857 0.857 0 0 1 -1.402 0l-5.483 -7.866c-1.653 -2.371 -4.104 -3.716 -6.692 -3.716Z"
				/>
				<path
					fill={fill}
					fillOpacity={fillOpacity}
					strokeWidth="0px"
					d="M28.5 43.576c-0.234 0 -0.456 -0.097 -0.621 -0.268L17.317 32.199c-0.923 -0.975 -1.562 -2.286 -1.784 -3.688 -0.222 -1.397 -0.046 -2.867 0.513 -4.138l0.228 -0.53c0.901 -2.069 2.651 -3.448 4.685 -3.694 2.046 -0.251 4.03 0.69 5.307 2.514L28.5 25.872l2.234 -3.203c1.129 -1.624 2.833 -2.554 4.663 -2.554 1.123 0 2.217 0.353 3.163 1.026 0.929 0.661 1.676 1.596 2.16 2.707l0.234 0.53c0.553 1.271 0.735 2.742 0.513 4.138 -0.228 1.402 -0.861 2.713 -1.784 3.688L29.121 43.314c-0.16 0.171 -0.388 0.268 -0.621 0.268ZM21.603 21.814c-0.142 0 -0.291 0.011 -0.433 0.028 -1.425 0.171 -2.668 1.174 -3.323 2.679l-0.228 0.53c-0.427 0.98 -0.564 2.109 -0.393 3.186 0.171 1.066 0.644 2.058 1.339 2.782l9.946 10.46 9.946 -10.46c0.69 -0.724 1.163 -1.716 1.334 -2.782 0.171 -1.077 0.034 -2.206 -0.388 -3.186l-0.234 -0.53c-0.359 -0.821 -0.906 -1.51 -1.585 -1.995 -0.655 -0.467 -1.408 -0.712 -2.172 -0.712 -1.265 0 -2.457 0.667 -3.26 1.824l-2.935 4.212a0.857 0.857 0 0 1 -1.402 0l-2.935 -4.212c-0.809 -1.163 -2.006 -1.818 -3.26 -1.818Z"
				/>
			</svg.SVG>
		)
	}

	Lover.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.5",
	}
}

export const ProgressCheck = (props: svg.SVGProps) => {
	const { stroke, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
			<path d="M8 12L11 15L17 9" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg.SVG>
	)
}

ProgressCheck.defaultProps = {
	stroke: theme.colors.white,
}

export const Restart = (props: svg.SVGProps) => {
	const { stroke, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...rest}>
			<path
				d="M8.50012 2.125C10.0039 2.12502 11.4594 2.65668 12.6091 3.62599C13.7589 4.59531 14.5289 5.93987 14.7832 7.42205C15.0375 8.90423 14.7596 10.4286 13.9987 11.7257C13.2378 13.0228 12.0428 14.0092 10.625 14.5104C9.20713 15.0117 7.65774 14.9956 6.25064 14.465C4.84353 13.9344 3.6693 12.9234 2.93549 11.6107C2.20168 10.2981 1.95554 8.76831 2.24056 7.29173C2.52559 5.81516 3.32343 4.48688 4.49307 3.54167"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.125 3.1875H4.95833V6.02083"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

Restart.defaultProps = {
	stroke: theme.colors.grey.dark50,
}

export const EyeHide = (props: svg.SVGProps) => {
	const { fill, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...rest}>
			<g clipPath="url(#clip0_557_6836)">
				<path
					d="M11.1955 9.06673C11.3232 8.72564 11.3879 8.36424 11.3866 8.00006C11.3866 7.19145 11.0654 6.41595 10.4936 5.84417C9.92187 5.27239 9.14637 4.95117 8.33776 4.95117C7.97806 4.95159 7.62134 5.01631 7.28442 5.14228L7.99998 5.88006C8.10875 5.86266 8.21871 5.85374 8.32887 5.85339C8.90062 5.8522 9.44961 6.07728 9.85598 6.47948C10.2623 6.88168 10.4931 7.42833 10.4978 8.00006C10.4974 8.11022 10.4885 8.22017 10.4711 8.32895L11.1955 9.06673Z"
					fill={fill}
				/>
				<path
					d="M15.2399 7.79112C13.7421 5.02224 11.1154 3.34668 8.20877 3.34668C7.41737 3.34854 6.63129 3.47605 5.87988 3.72446L6.59544 4.44446C7.12248 4.30825 7.66442 4.23808 8.20877 4.23557C10.711 4.23557 12.9865 5.63112 14.3421 7.98223C13.8448 8.8545 13.1856 9.62383 12.3999 10.2489L13.031 10.88C13.9404 10.1464 14.6956 9.2401 15.2532 8.21335L15.3688 8.00001L15.2399 7.79112Z"
					fill={fill}
				/>
				<path
					d="M2.16453 2.56896L4.14675 4.55118C2.89383 5.3579 1.86982 6.47375 1.17342 7.79118L1.05786 8.00007L1.17342 8.2134C2.67119 10.9823 5.29786 12.6578 8.20453 12.6578C9.33904 12.6576 10.4588 12.4008 11.4801 11.9067L13.7023 14.129L14.4801 13.4623L2.92453 1.90674L2.16453 2.56896ZM6.49786 6.90229L9.45342 9.85785C9.11947 10.0646 8.73504 10.1753 8.34231 10.1778C8.05694 10.1779 7.77439 10.1214 7.51092 10.0118C7.24744 9.90222 7.00824 9.74159 6.80708 9.53919C6.60592 9.33679 6.44676 9.09661 6.33878 8.83246C6.23079 8.56832 6.1761 8.28543 6.17786 8.00007C6.18287 7.61188 6.29349 7.23237 6.49786 6.90229ZM5.85342 6.25785C5.43761 6.84425 5.24272 7.55887 5.30325 8.27518C5.36377 8.99148 5.67582 9.66327 6.18413 10.1716C6.69244 10.6799 7.36422 10.9919 8.08053 11.0525C8.79684 11.113 9.51146 10.9181 10.0979 10.5023L10.809 11.2134C9.98576 11.5653 9.09979 11.7467 8.20453 11.7467C5.7023 11.7467 3.42675 10.3512 2.07119 8.00007C2.72173 6.84817 3.65863 5.88372 4.79119 5.20007L5.85342 6.25785Z"
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id="clip0_557_6836">
					<rect width="16" height="16" fill={fill} />
				</clipPath>
			</defs>
		</svg.SVG>
	)
}

EyeHide.defaultProps = {
	fill: theme.colors.white,
}

export const Done = (props: svg.SVGProps) => {
	const { stroke, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...rest}>
			<path
				d="M4 8.47222L7.47222 11.9444L14.4167 5"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

Done.defaultProps = {
	stroke: theme.colors.white,
}

export const DoneAll = (props: svg.SVGProps) => {
	const { stroke, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...rest}>
			<path
				d="M5.30547 8.77789L5.7395 9.21191M15.7221 5.30566L8.7777 12.2501L8.34367 11.8161M1.83325 8.77789L5.30547 12.2501L12.2499 5.30566"
				stroke={stroke}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

DoneAll.defaultProps = {
	stroke: theme.colors.white,
}

export const Trash = (props: svg.SVGProps) => {
	const { fill, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...rest}>
			<path
				d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM7.875 11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125V11.8125ZM11.25 11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125V11.8125ZM11.25 3.375H6.75V2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375Z"
				fill={fill}
			/>
		</svg.SVG>
	)
}

Trash.defaultProps = {
	fill: theme.colors.grey.dark50,
}

export const Pen = (props: svg.SVGProps) => {
	const { fill, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" {...rest}>
			<path
				d="M1.875 10.7813V13.1251H4.21875L11.1312 6.21256L8.7875 3.86881L1.875 10.7813ZM12.9437 4.40006C13.0017 4.34224 13.0477 4.27356 13.079 4.19795C13.1104 4.12234 13.1265 4.04129 13.1265 3.95944C13.1265 3.87758 13.1104 3.79653 13.079 3.72092C13.0477 3.64531 13.0017 3.57663 12.9437 3.51881L11.4813 2.05631C11.4234 1.99837 11.3547 1.95241 11.2791 1.92104C11.2035 1.88968 11.1225 1.87354 11.0406 1.87354C10.9588 1.87354 10.8777 1.88968 10.8021 1.92104C10.7265 1.95241 10.6578 1.99837 10.6 2.05631L9.45625 3.20006L11.8 5.54381L12.9437 4.40006Z"
				fill={fill}
			/>
		</svg.SVG>
	)
}

Pen.defaultProps = {
	fill: theme.colors.grey.dark50alpha40,
}

export const Help = (props: svg.SVGProps) => {
	const { fill, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" {...rest}>
			<path
				d="M13.75 7.5C13.75 9.1576 13.0915 10.7473 11.9194 11.9194C10.7473 13.0915 9.1576 13.75 7.5 13.75C5.8424 13.75 4.25269 13.0915 3.08058 11.9194C1.90848 10.7473 1.25 9.1576 1.25 7.5C1.25 5.8424 1.90848 4.25269 3.08058 3.08058C4.25269 1.90848 5.8424 1.25 7.5 1.25C9.1576 1.25 10.7473 1.90848 11.9194 3.08058C13.0915 4.25269 13.75 5.8424 13.75 7.5ZM6.875 8.125V10C6.875 10.1658 6.94085 10.3247 7.05806 10.4419C7.17527 10.5592 7.33424 10.625 7.5 10.625C7.66576 10.625 7.82473 10.5592 7.94194 10.4419C8.05915 10.3247 8.125 10.1658 8.125 10V8.125C8.125 7.95924 8.05915 7.80027 7.94194 7.68306C7.82473 7.56585 7.66576 7.5 7.5 7.5C7.33424 7.5 7.17527 7.56585 7.05806 7.68306C6.94085 7.80027 6.875 7.95924 6.875 8.125ZM7.5 4.6875C7.25136 4.6875 7.0129 4.78627 6.83709 4.96209C6.66127 5.1379 6.5625 5.37636 6.5625 5.625C6.5625 5.87364 6.66127 6.1121 6.83709 6.28791C7.0129 6.46373 7.25136 6.5625 7.5 6.5625C7.74864 6.5625 7.9871 6.46373 8.16291 6.28791C8.33873 6.1121 8.4375 5.87364 8.4375 5.625C8.4375 5.37636 8.33873 5.1379 8.16291 4.96209C7.9871 4.78627 7.74864 4.6875 7.5 4.6875Z"
				fill={fill}
				fillOpacity="0.3"
			/>
		</svg.SVG>
	)
}

Help.defaultProps = {
	fill: theme.colors.grey.dark50,
}

export const Favorite = (props: svg.SVGProps) => {
	const { fill, stroke, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" id="love" {...rest}>
			<path
				fill={fill}
				stroke={stroke}
				strokeWidth="2"
				d="M4.379 12.274A4.841 4.841 0 0 1 3 8.89C3 6.189 5.216 4 7.95 4c1.674 0 3.154.82 4.05 2.077A4.962 4.962 0 0 1 16.05 4C18.784 4 21 6.189 21 8.889a4.845 4.845 0 0 1-1.507 3.512L12 20l-7.621-7.726Z"
			></path>
		</svg.SVG>
	)
}

Favorite.defaultProps = {
	fill: "none",
	stroke: theme.colors.grey.dark50,
}

export namespace guideline {
	export const InProgress = (props: svg.SVGProps) => {
		const { stroke, fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none" {...rest}>
				<path d="M1 6H10C10 8.20914 8.20914 10 6 10H5C2.79086 10 1 8.20914 1 6Z" fill={fill} />
				<circle cx="5.5" cy="5.5" r="5" stroke={stroke} />
			</svg.SVG>
		)
	}

	InProgress.defaultProps = {
		stroke: theme.colors.grey.dark50,
		fill: theme.colors.grey.dark50,
	}

	export const Pending = (props: svg.SVGProps) => {
		const { stroke, strokeOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none" {...rest}>
				<circle cx="5.5" cy="5.5" r="5" stroke={stroke} strokeOpacity={strokeOpacity} />
			</svg.SVG>
		)
	}

	Pending.defaultProps = {
		stroke: theme.colors.grey.dark50,
		strokeOpacity: "0.3",
	}

	export const Completed = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none" {...rest}>
				<circle cx="5.5" cy="5.5" r="5.5" fill={fill} fillOpacity={fillOpacity} />
			</svg.SVG>
		)
	}

	Completed.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.7",
	}
}

export namespace arrows {
	export const ArrowBack = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...rest}>
				<path
					d="M15 7.00004H3.83005L8.71005 2.12004C9.10005 1.73004 9.10005 1.09004 8.71005 0.700037C8.61753 0.607333 8.50764 0.533785 8.38667 0.483604C8.2657 0.433422 8.13602 0.407593 8.00505 0.407593C7.87408 0.407593 7.7444 0.433422 7.62342 0.483604C7.50245 0.533785 7.39256 0.607333 7.30005 0.700037L0.710047 7.29004C0.617343 7.38255 0.543796 7.49244 0.493614 7.61341C0.443433 7.73439 0.417603 7.86407 0.417603 7.99504C0.417603 8.12601 0.443433 8.25569 0.493614 8.37666C0.543796 8.49763 0.617343 8.60752 0.710047 8.70004L7.30005 15.29C7.39263 15.3826 7.50254 15.4561 7.6235 15.5062C7.74447 15.5563 7.87412 15.5821 8.00505 15.5821C8.13598 15.5821 8.26563 15.5563 8.38659 15.5062C8.50755 15.4561 8.61747 15.3826 8.71005 15.29C8.80263 15.1975 8.87607 15.0875 8.92617 14.9666C8.97628 14.8456 9.00207 14.716 9.00207 14.585C9.00207 14.4541 8.97628 14.3245 8.92617 14.2035C8.87607 14.0825 8.80263 13.9726 8.71005 13.88L3.83005 9.00004H15C15.55 9.00004 16 8.55004 16 8.00004C16 7.45004 15.55 7.00004 15 7.00004Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	ArrowBack.defaultProps = {
		fill: theme.colors.grey.dark50,
	}

	export const PlacementArrowDown = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="16" height="25" viewBox="0 0 16 25" fill="none" {...rest}>
				<path
					d="M7.29289 24.7071C7.68342 25.0976 8.31658 25.0976 8.70711 24.7071L15.0711 18.3431C15.4616 17.9526 15.4616 17.3195 15.0711 16.9289C14.6805 16.5384 14.0474 16.5384 13.6569 16.9289L8 22.5858L2.34315 16.9289C1.95262 16.5384 1.31946 16.5384 0.928932 16.9289C0.538408 17.3195 0.538408 17.9526 0.928932 18.3431L7.29289 24.7071ZM7 1.19249e-08L7 24L9 24L9 -1.19249e-08L7 1.19249e-08Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	PlacementArrowDown.defaultProps = {
		fill: theme.colors.grey.dark50alpha80,
	}

	export const ArrowLeftRight = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="62" height="8" viewBox="0 0 62 8" fill="none" {...rest}>
				<path
					d="M0.646447 3.79684C0.451184 3.9921 0.451184 4.30868 0.646447 4.50394L3.82843 7.68592C4.02369 7.88119 4.34027 7.88119 4.53553 7.68592C4.7308 7.49066 4.7308 7.17408 4.53553 6.97882L1.70711 4.15039L4.53553 1.32196C4.7308 1.1267 4.7308 0.810119 4.53553 0.614857C4.34027 0.419595 4.02369 0.419595 3.82843 0.614857L0.646447 3.79684ZM61.3536 4.50394C61.5488 4.30868 61.5488 3.9921 61.3536 3.79684L58.1716 0.614857C57.9763 0.419595 57.6597 0.419595 57.4645 0.614857C57.2692 0.810119 57.2692 1.1267 57.4645 1.32196L60.2929 4.15039L57.4645 6.97882C57.2692 7.17408 57.2692 7.49066 57.4645 7.68592C57.6597 7.88119 57.9763 7.88119 58.1716 7.68592L61.3536 4.50394ZM1 4.65039H61V3.65039H1V4.65039Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	ArrowLeftRight.defaultProps = {
		fill: theme.colors.grey.dark50alpha80,
	}

	export const ArrowUpDown = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="16" height="138" viewBox="0 0 16 138" fill="none" {...rest}>
				<path
					d="M8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM7.29289 137.707C7.68341 138.098 8.31658 138.098 8.7071 137.707L15.0711 131.343C15.4616 130.953 15.4616 130.319 15.0711 129.929C14.6805 129.538 14.0474 129.538 13.6568 129.929L7.99999 135.586L2.34314 129.929C1.95262 129.538 1.31945 129.538 0.928927 129.929C0.538402 130.319 0.538402 130.953 0.928926 131.343L7.29289 137.707ZM7 1L6.99999 137L8.99999 137L9 1L7 1Z"
					fill={fill}
					fillOpacity="0.7"
				/>
			</svg.SVG>
		)
	}

	ArrowUpDown.defaultProps = {
		fill: theme.colors.grey.dark50alpha80,
	}

	export const PlacementArrowUp = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="16" height="25" viewBox="0 0 16 25" fill="none" {...rest}>
				<path
					d="M8.70711 0.292892C8.31658 -0.0976314 7.68342 -0.0976315 7.29289 0.292892L0.928933 6.65685C0.538409 7.04738 0.538409 7.68054 0.928933 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292892ZM9 25L9 1L7 1L7 25L9 25Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	PlacementArrowUp.defaultProps = {
		fill: theme.colors.grey.dark50alpha80,
	}

	export const PlacementArrowLeft = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16" fill="none" {...rest}>
				<path
					d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7L1 9L25 9L25 7Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	PlacementArrowLeft.defaultProps = {
		fill: theme.colors.grey.dark50alpha80,
	}

	export const PlacementArrowRight = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16" fill="none" {...rest}>
				<path
					d="M24.7071 8.70711C25.0976 8.31658 25.0976 7.68342 24.7071 7.29289L18.3431 0.928931C17.9526 0.538407 17.3195 0.538407 16.9289 0.928931C16.5384 1.31946 16.5384 1.95262 16.9289 2.34314L22.5858 8L16.9289 13.6569C16.5384 14.0474 16.5384 14.6805 16.9289 15.0711C17.3195 15.4616 17.9526 15.4616 18.3431 15.0711L24.7071 8.70711ZM5.56363e-08 9L24 9L24 7L-5.56363e-08 7L5.56363e-08 9Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	PlacementArrowRight.defaultProps = {
		fill: theme.colors.grey.dark50alpha80,
	}

	export const SmallRight = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" {...rest}>
				<path
					d="M0.641749 5.50747L7.81007 5.50747L4.67834 8.6392C4.42806 8.88948 4.42806 9.3002 4.67834 9.55048C4.73771 9.60998 4.80823 9.65717 4.88587 9.68938C4.9635 9.72158 5.04673 9.73816 5.13077 9.73816C5.21482 9.73816 5.29805 9.72158 5.37568 9.68938C5.45331 9.65717 5.52384 9.60998 5.58321 9.55048L9.81232 5.32137C9.87182 5.262 9.91902 5.19147 9.95122 5.11384C9.98342 5.03621 10 4.95298 10 4.86893C10 4.78488 9.98342 4.70166 9.95122 4.62403C9.91902 4.54639 9.87182 4.47587 9.81233 4.4165L5.58321 0.187382C5.52379 0.127968 5.45326 0.0808388 5.37563 0.0486847C5.298 0.0165296 5.2148 -2.04455e-05 5.13077 -2.04528e-05C5.04675 -2.04602e-05 4.96355 0.0165296 4.88592 0.0486846C4.80829 0.0808387 4.73776 0.127968 4.67834 0.187382C4.61893 0.246796 4.5718 0.317332 4.53964 0.394961C4.50749 0.472589 4.49094 0.555791 4.49094 0.639816C4.49094 0.72384 4.50749 0.807041 4.53964 0.88467C4.5718 0.962298 4.61893 1.03283 4.67834 1.09225L7.81007 4.22398L0.641749 4.22398C0.288787 4.22398 4.56819e-07 4.51276 4.25962e-07 4.86572C3.95105e-07 5.21869 0.288787 5.50747 0.641749 5.50747Z"
					fill={fill}
					fillOpacity="0.8"
				/>
			</svg.SVG>
		)
	}

	SmallRight.defaultProps = {
		fill: theme.colors.grey.dark50,
	}
}

export namespace marks {
	export const Accept = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 10 10" fill="none" {...rest}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10ZM7.0746 4.36446C7.2257 4.22281 7.23335 3.9855 7.0917 3.8344C6.95005 3.68331 6.71274 3.67566 6.56165 3.8173L4.39388 5.84958L3.43824 4.95367C3.28715 4.81202 3.04983 4.81967 2.90819 4.97077C2.76654 5.12186 2.77419 5.35917 2.92528 5.50082L4.13741 6.63719C4.28165 6.77242 4.50611 6.77242 4.65036 6.63719L7.0746 4.36446Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	Accept.defaultProps = {
		fill: theme.colors.grey.dark50,
	}

	export const Reject = (props: svg.SVGProps) => {
		const { fill, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...rest}>
				<path
					d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433281 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9972 7.34869 18.9427 4.80678 17.068 2.93202C15.1932 1.05727 12.6513 0.00279983 10 0ZM13.6212 12.5327C13.6926 12.6042 13.7493 12.689 13.788 12.7824C13.8267 12.8758 13.8466 12.9758 13.8466 13.0769C13.8466 13.178 13.8267 13.2781 13.788 13.3715C13.7493 13.4648 13.6926 13.5497 13.6212 13.6212C13.5497 13.6926 13.4648 13.7493 13.3715 13.788C13.2781 13.8267 13.178 13.8466 13.0769 13.8466C12.9759 13.8466 12.8758 13.8267 12.7824 13.788C12.689 13.7493 12.6042 13.6926 12.5327 13.6212L10 11.0875L7.46731 13.6212C7.39584 13.6926 7.311 13.7493 7.21762 13.788C7.12424 13.8267 7.02415 13.8466 6.92308 13.8466C6.82201 13.8466 6.72192 13.8267 6.62854 13.788C6.53517 13.7493 6.45032 13.6926 6.37885 13.6212C6.30738 13.5497 6.25069 13.4648 6.21201 13.3715C6.17333 13.2781 6.15342 13.178 6.15342 13.0769C6.15342 12.9758 6.17333 12.8758 6.21201 12.7824C6.25069 12.689 6.30738 12.6042 6.37885 12.5327L8.9125 10L6.37885 7.46731C6.23451 7.32297 6.15342 7.1272 6.15342 6.92308C6.15342 6.71895 6.23451 6.52318 6.37885 6.37885C6.52319 6.23451 6.71895 6.15342 6.92308 6.15342C7.12721 6.15342 7.32297 6.23451 7.46731 6.37885L10 8.9125L12.5327 6.37885C12.6042 6.30738 12.689 6.25068 12.7824 6.212C12.8758 6.17333 12.9759 6.15342 13.0769 6.15342C13.178 6.15342 13.2781 6.17333 13.3715 6.212C13.4648 6.25068 13.5497 6.30738 13.6212 6.37885C13.6926 6.45031 13.7493 6.53516 13.788 6.62854C13.8267 6.72192 13.8466 6.822 13.8466 6.92308C13.8466 7.02415 13.8267 7.12423 13.788 7.21761C13.7493 7.31099 13.6926 7.39584 13.6212 7.46731L11.0875 10L13.6212 12.5327Z"
					fill={fill}
				/>
			</svg.SVG>
		)
	}

	Reject.defaultProps = {
		fill: theme.colors.grey.dark50,
	}
}

export namespace actions {
	export const Accept = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg.SVG xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none" {...rest}>
				<mask id="mask0_894_5124" maskUnits="userSpaceOnUse" x="4" y="4" width="17" height="18">
					<path
						d="M12.5 20.1343C13.4851 20.1355 14.4607 19.9421 15.3708 19.5651C16.281 19.1881 17.1076 18.635 17.8032 17.9375C18.5007 17.2419 19.0539 16.4152 19.4309 15.5051C19.8079 14.595 20.0013 13.6194 20 12.6343C20.0012 11.6492 19.8078 10.6735 19.4308 9.76344C19.0538 8.85333 18.5007 8.0267 17.8032 7.33103C17.1076 6.63354 16.281 6.08041 15.3708 5.70342C14.4607 5.32642 13.4851 5.13301 12.5 5.13428C11.5149 5.13303 10.5393 5.32645 9.62916 5.70344C8.71906 6.08043 7.89242 6.63356 7.19675 7.33103C6.49928 8.0267 5.94616 8.85333 5.56917 9.76344C5.19218 10.6735 4.99875 11.6492 5.00001 12.6343C4.99873 13.6194 5.19215 14.595 5.56914 15.5051C5.94613 16.4152 6.49927 17.2419 7.19675 17.9375C7.89242 18.635 8.71906 19.1881 9.62916 19.5651C10.5393 19.9421 11.5149 20.1355 12.5 20.1343Z"
						fill="white"
						stroke="white"
						strokeWidth="2"
						strokeLinejoin="round"
					/>
					<path
						d="M9.5 12.6343L11.75 14.8843L16.25 10.3843"
						stroke="black"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</mask>
				<g mask="url(#mask0_894_5124)">
					<path d="M3.5 3.63428H21.5V21.6343H3.5V3.63428Z" fill={fill} fillOpacity={fillOpacity} />
				</g>
			</svg.SVG>
		)
	}

	Accept.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.3",
	}

	export const Reject = (props: svg.SVGProps) => {
		const { fill, fillOpacity, ...rest } = props
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none" {...rest}>
				<mask id="mask0_894_5131" maskUnits="userSpaceOnUse" x="4" y="4" width="17" height="18">
					<path
						d="M12.5 20.1343C16.6423 20.1343 20 16.7765 20 12.6343C20 8.49203 16.6423 5.13428 12.5 5.13428C8.35775 5.13428 5 8.49203 5 12.6343C5 16.7765 8.35775 20.1343 12.5 20.1343Z"
						fill="white"
						stroke="white"
						strokeWidth="2"
						strokeLinejoin="round"
					/>
					<path
						d="M14.6212 10.5127L10.3784 14.7554M10.3784 10.5127L14.6212 14.7554"
						stroke="black"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</mask>
				<g mask="url(#mask0_894_5131)">
					<path d="M3.5 3.63428H21.5V21.6343H3.5V3.63428Z" fill={fill} fillOpacity={fillOpacity} />
				</g>
			</svg>
		)
	}

	Reject.defaultProps = {
		fill: theme.colors.grey.dark50,
		fillOpacity: "0.3",
	}
	export namespace typography {
		export const Add = (props: svg.SVGProps) => {
			const { stroke, ...rest } = props
			return (
				<svg.SVG xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...rest}>
					<path
						d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
						stroke={stroke}
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path d="M4.42871 7H9.57157" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
					<path d="M7 4.42847V9.57133" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
				</svg.SVG>
			)
		}

		Add.defaultProps = {
			stroke: theme.colors.blue.blue,
		}
	}
}
